import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1600px;
  margin: 30px auto 30px auto;
  padding:0 80px;

  @media (max-width: 1280px) {
    padding:0 60px;
  }

  @media (max-width: 992px) {
    justify-content: center;
    padding:0 20px;
    margin: 0 auto;
  }
`;

export const FlexContainer = styled.div`
  max-width: 1600px;
  padding:0 80px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1280px) {
    padding:0 60px;
  }

  @media (max-width: 992px) {
    justify-content: center;
    padding:0 20px;
  }
`;

export const NarrowColumn = styled.div`
  margin: 0 15%;
`;



// WEBPACK FOOTER //
// ./src/theme/Grid.js